import React, { Suspense, ReactNode } from 'react';
import useMinimumLoadingTime from './useMinimumLoadingTime';

interface SuspenseWithMinimumLoadingTimeProps {
  children?: ReactNode;
  fallback?: ReactNode;
  minimumLoadingTime?: number;
}

function SuspenseWithMinimumLoading({
  children,
  fallback,
  minimumLoadingTime = 300,
}: SuspenseWithMinimumLoadingTimeProps) {
  // const isLoading = useMinimumLoadingTime(minimumLoadingTime);

  return <Suspense fallback={fallback}>{children}</Suspense>;
}

export default SuspenseWithMinimumLoading;
